const fileUploadSelector = (state) => state.fileUpload;

const fileUploadingSelector = (state) => fileUploadSelector(state).uploading;

export { fileUploadSelector, fileUploadingSelector };
